import { render, staticRenderFns } from "./PromotionViewPage.vue?vue&type=template&id=a3d0f86a&"
import script from "./PromotionViewPage.vue?vue&type=script&lang=js&"
export * from "./PromotionViewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports